import React, { useEffect } from "react";
import Layout from "../layout";
import FormUpdateOrderPetani from "../../component/FormUpdatePetaniOrder";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const UpdateOrderPetani = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);
  return (
    <Layout>
      <FormUpdateOrderPetani />
    </Layout>
  );
};

export default UpdateOrderPetani;
